// src/pages/admin/AdminDashboard.jsx

import React, { useEffect, useState } from 'react';
import { adminAPI, jobAdPublicAPI } from '../../services/api';
import { StatCard, Spinner } from '../../components/shared/UI';
import { Users, Briefcase, Settings, TrendingUp } from 'lucide-react';

export const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      adminAPI.getUsers({ limit: 1 }),
      jobAdPublicAPI.getActive(),
    ]).then(([usersRes, jobsRes]) => {
      setStats({
        totalUsers: usersRes.data.data?.total || 0,
        activeJobs: (jobsRes.data.data?.ads || []).length,
      });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><Spinner size={32} /></div>;

  return (
    <div className="space-y-8 animate-fade-in">
      <div>
        <h1 className="font-display font-800 text-2xl text-white">Admin Overview</h1>
        <p className="text-gray-500 text-sm mt-1">Platform health and configuration</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Total Users" value={stats?.totalUsers || '—'} icon={Users} color="text-tikhet-amber" />
        <StatCard label="Active Jobs" value={stats?.activeJobs || '—'} icon={Briefcase} color="text-tikhet-teal" />
        <StatCard label="Match Engine" value="Online" icon={TrendingUp} color="text-tikhet-sky" />
        <StatCard label="API Status" value="Healthy" icon={Settings} color="text-tikhet-rose" />
      </div>

    </div>
  );
};
